import React from 'react';
import './Homepage.css';
import HeaderComponent from '../../components/HeaderComponent';
import SearchComponent from '../../components/SearchComponent';
import ModelLangStatsChart from '../analytics/ModelLangStatsChart';
import ScoreAnalyticsTable from '../analytics/ScoreAnalyticsTable';

const Homepage: React.FC = () => {

  return (
    <div className="homepage">
      <HeaderComponent />
      <SearchComponent />
      <div className="content-home">
        <h3>Registry for planning domain is a repository that contains domain model and comprehensive information related to domain models.
          The purpose of the application is to help AI planning developers understand the domain models and modelling process.
        </h3>
        <p>To understand how to use this application, click on "How it works" section in navigation bar</p>
        
      </div>
      <div className='container'>
        <div className='table-wrapper'>
          <ScoreAnalyticsTable />
        </div>
        <div className='table-wrapper'>
          <ModelLangStatsChart />
        </div>
      </div>
    </div>
  );
};

export default Homepage;
